import React, { useState } from "react";
import { 
  Box, 
  Card, 
  Typography, 
  IconButton, 
  Drawer, 
  List, 
  ListItem 
} from "@mui/material";
import { Link as RouterLink, useLocation } from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import logo from "../assets/brothers_fiber.png";
import { TiPhoneOutline } from "react-icons/ti";

const navLinks = [
  { label: "Home", path: "/" },
  { label: "About Us", path: "/about-us" },
  { label: "Contact Us", path: "/contact-us" },
  { label: "Services", path: "/services" },
];

function Header() {
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <>
      <Card sx={{ borderRadius: 0, boxShadow: 0 }}>
        <Box
          sx={{
            background: "black",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            px: { xs: 2, md: 4 },
            py: 1,
          }}
        >
          {/* Logo - Botão para Home */}
          <RouterLink
            to="/"
            style={{
              display: "flex",
              alignItems: "center",
              textDecoration: "none",
            }}
          >
            <Box
              component="img"
              src={logo}
              alt="Brothers Fiber Logo"
              sx={{
                height: 48,
                transition: "opacity 0.3s ease",
                "&:hover": {
                  opacity: 0.8,
                },
                cursor: "pointer",
              }}
            />
          </RouterLink>

          {/* Desktop Navigation */}
          <Box
            sx={{
              display: { xs: "none", md: "flex" },
              gap: 4,
              justifyContent: "center",
              flexGrow: 1,
              marginLeft: "-303px",
            }}
          >
            {navLinks.map((link) => {
              const isActive = location.pathname === link.path;

              return (
                <RouterLink
                  key={link.label}
                  to={link.path}
                  style={{
                    textDecoration: "none",
                    color: isActive ? "#3AC3E3" : "white",
                    fontWeight: isActive ? 600 : 500,
                    fontSize: "18px",
                    transition: "all 0.3s ease",
                    padding: "8px 12px",
                    borderRadius: "4px",
                  }}
                  onMouseEnter={(e) => {
                    if (!isActive) {
                      e.currentTarget.style.color = "#3AC3E3";
                      e.currentTarget.style.backgroundColor = "rgba(58, 195, 227, 0.1)";
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (!isActive) {
                      e.currentTarget.style.color = "white";
                      e.currentTarget.style.backgroundColor = "transparent";
                    }
                  }}
                >
                  <Typography variant="body1">{link.label}</Typography>
                </RouterLink>
              );
            })}

            <Box sx={{ 
              display: "flex", 
              alignItems: "center", 
              mb: 0.5, 
              position: "absolute", 
              right: 16, 
              top: 5 
            }}>
              <IconButton 
                color="primary" 
                size="large"
                sx={{
                  '&:hover': {
                    backgroundColor: 'rgba(58, 195, 227, 0.1)',
                  }
                }}
              >
                <TiPhoneOutline size={28} color="white" />
              </IconButton>
              <Typography
                variant="body1"
                color="white"
                sx={{ fontWeight: 500 }}
              >
                +1 515 850 9012
              </Typography>
            </Box>
          </Box>

          {/* Mobile Menu Button */}
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{
              display: { md: "none" },
              color: "white",
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
              }
            }}
          >
            <MenuIcon />
          </IconButton>
        </Box>
      </Card>

      {/* Mobile Drawer */}
      <Drawer
        variant="temporary"
        anchor="right"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{ keepMounted: true }}
        sx={{
          display: { xs: "block", md: "none" },
          "& .MuiDrawer-paper": {
            boxSizing: "border-box",
            width: 250,
            background: "black",
            color: "white",
          },
        }}
      >
        <Box sx={{ 
          p: 2, 
          display: "flex", 
          justifyContent: "flex-end",
          borderBottom: "1px solid rgba(255, 255, 255, 0.1)"
        }}>
          <IconButton 
            onClick={handleDrawerToggle} 
            sx={{ 
              color: "white",
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
              }
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
        <List sx={{ py: 2 }}>
          {navLinks.map((link) => {
            const isActive = location.pathname === link.path;

            return (
              <ListItem key={link.label} disablePadding>
                <RouterLink
                  to={link.path}
                  onClick={handleDrawerToggle}
                  style={{
                    textDecoration: "none",
                    color: isActive ? "#3AC3E3" : "white",
                    fontWeight: isActive ? 600 : 500,
                    fontSize: "18px",
                    padding: "16px",
                    width: "100%",
                    transition: "all 0.3s ease",
                    display: "block",
                  }}
                  onMouseEnter={(e) => {
                    if (!isActive) {
                      e.currentTarget.style.color = "#3AC3E3";
                      e.currentTarget.style.backgroundColor = "rgba(58, 195, 227, 0.1)";
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (!isActive) {
                      e.currentTarget.style.color = "white";
                      e.currentTarget.style.backgroundColor = "transparent";
                    }
                  }}
                >
                  {link.label}
                </RouterLink>
              </ListItem>
            );
          })}
        </List>
      </Drawer>
    </>
  );
}

export default Header; 